<template>
  <div class="gestiune-order-errors">
    <div class="card mar-to-15">
      <div class="card-content">
        <div class="mar-b-15">
          <h5>{{ $t('gestiune.orderErrors') }}</h5>
          <div class="info-text">
            Comenzile care nu au putut fi trimise în gestiune. Trimiterea automată se reîncearcă de 3 ori;
            după a 3-a eroare comanda poate fi retrimisă doar de aici. Click pe o comandă pentru a vedea ce s-a trimis și ce a răspuns gestiunea.
          </div>
        </div>

        <div class="filters-row">
          <select v-model="filters.location_id" class="form-control" @change="search">
            <option value="">Toate locațiile</option>
            <option v-for="location in locations" :key="location.true_id" :value="location.true_id">
              {{ location.name }}
            </option>
          </select>
          <input
            type="number"
            class="form-control"
            v-model="filters.search"
            placeholder="ID comandă"
            @keyup.enter="search"
          />
          <label class="only-final">
            <input type="checkbox" v-model="filters.only_final" @change="search" />
            Doar erori finale (3 încercări)
          </label>
          <button class="btn btn-icon btn-success mar-rt-10 save" @click="search">Caută</button>
          <button
            class="btn btn-icon btn-success mar-rt-10 save"
            :disabled="!selectedIds.length || resending"
            @click="resend"
          >
            {{ resending ? 'Se retrimite...' : 'Retrimite (' + selectedIds.length + ')' }}
          </button>
        </div>

        <div class="data-table" v-loading="loading">
          <el-table
            ref="ordersTable"
            :data="orders"
            row-key="id"
            style="width: 100%"
            class="clickable-rows"
            @selection-change="onSelectionChange"
            @row-click="openLogs"
          >
            <el-table-column type="selection" width="45"></el-table-column>
            <el-table-column label="ID comandă" prop="id" width="110"></el-table-column>
            <el-table-column label="Data" prop="created_at" width="160"></el-table-column>
            <el-table-column label="Locație" prop="location_name"></el-table-column>
            <el-table-column label="Nr. bon" prop="receipt_nr" width="90">
              <template slot-scope="{ row }">{{ row.receipt_nr || '-' }}</template>
            </el-table-column>
            <el-table-column label="Total" prop="total" width="90"></el-table-column>
            <el-table-column label="Încercări" width="100">
              <template slot-scope="{ row }">
                <span class="badge" :class="row.is_final ? 'badge-danger' : 'badge-warning'">
                  {{ row.error_level }} / 3
                </span>
              </template>
            </el-table-column>
            <el-table-column label="Ultima eroare" min-width="260">
              <template slot-scope="{ row }">
                <div class="last-error">{{ row.last_error || '-' }}</div>
                <small v-if="row.last_details" class="last-details">{{ row.last_details }}</small>
              </template>
            </el-table-column>
            <el-table-column label="Ultima încercare" prop="last_attempt_at" width="160">
              <template slot-scope="{ row }">{{ row.last_attempt_at || '-' }}</template>
            </el-table-column>
          </el-table>

          <el-pagination
            class="active-pagination width-table mar-to-15"
            :total="pagination.total"
            :page-size="pagination.perPage"
            :current-page="pagination.page"
            layout="prev, pager, next, total"
            @current-change="handlePageChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <vmodal name="gestiuneOrderLogsModal" height="auto" width="950" :adaptive="true" :scrollable="true">
      <div class="card">
        <div class="card-content">
          <div class="modal-header">
            <p>Istoric trimitere în gestiune — comanda #{{ logsOrderId }}</p>
          </div>
          <div class="modal-body logs-modal-body" v-loading="logsLoading">
            <p v-if="!logsLoading && !logs.length">Nu există log-uri pentru această comandă.</p>
            <div v-for="log in logs" :key="log.id" class="log-entry" :class="log.status ? 'log-success' : 'log-error'">
              <div class="log-head">
                <span class="badge" :class="log.status ? 'badge-success' : 'badge-danger'">
                  {{ log.status ? 'Succes' : 'Eroare' }}
                </span>
                <strong>{{ log.created_at }}</strong>
                <span>· {{ log.source === 'manual' ? 'Manual' + (log.user_name ? ' (' + log.user_name + ')' : '') : 'Automat (cron)' }}</span>
                <span>· gestiune_order_id: <code>{{ log.gestiune_order_id }}</code></span>
              </div>
              <div v-if="log.error" class="log-error-text">
                {{ log.error }}<span v-if="log.details"> — {{ log.details }}</span>
              </div>
              <div class="log-json">
                <div>
                  <div class="json-label">
                    <label>Trimis</label>
                    <a class="copy-json" @click="copyJson(log.data_to, log.id + '-to')">
                      <i :class="copiedKey === log.id + '-to' ? 'ti-check' : 'ti-clipboard'"></i>
                      {{ copiedKey === log.id + '-to' ? 'Copiat!' : 'Copiază' }}
                    </a>
                  </div>
                  <pre>{{ pretty(log.data_to) }}</pre>
                </div>
                <div>
                  <div class="json-label">
                    <label>Primit</label>
                    <a class="copy-json" @click="copyJson(log.data_from, log.id + '-from')">
                      <i :class="copiedKey === log.id + '-from' ? 'ti-check' : 'ti-clipboard'"></i>
                      {{ copiedKey === log.id + '-from' ? 'Copiat!' : 'Copiază' }}
                    </a>
                  </div>
                  <pre>{{ pretty(log.data_from) }}</pre>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="button-group">
              <a @click="$modal.hide('gestiuneOrderLogsModal')" class="btn btn-danger btn-icon mar-rt-10 delete">{{ $t('general.cancel2') }}</a>
            </div>
          </div>
        </div>
      </div>
    </vmodal>
  </div>
</template>

<script>
  import swal from 'sweetalert2'
  import {Pagination, TableColumn} from 'element-ui'

  export default {
    components: {
      ElPagination: Pagination,
      ElTableColumn: TableColumn
    },
    props: {
      locations: {
        type: Array,
        required: true
      }
    },
    data () {
      return {
        orders: [],
        selectedIds: [],
        loading: false,
        resending: false,
        filters: {
          location_id: '',
          search: '',
          only_final: false
        },
        pagination: {
          page: 1,
          perPage: 20,
          total: 0
        },
        logs: [],
        logsOrderId: null,
        logsLoading: false,
        copiedKey: null
      }
    },
    created () {
      this.companyID = this.$session.get('selectedCompany')
      this.fetchOrders()
    },
    methods: {
      search () {
        this.pagination.page = 1
        this.fetchOrders()
      },
      handlePageChange (page) {
        this.pagination.page = page
        this.fetchOrders()
      },
      fetchOrders () {
        this.loading = true
        const dataToSend = {
          token: this.$session.get('token'),
          company_id: this.companyID,
          location_id: this.filters.location_id || null,
          search: this.filters.search || null,
          only_final: this.filters.only_final ? 1 : 0,
          page: this.pagination.page,
          per_page: this.pagination.perPage
        }
        this.apiRequest('/gestiune/order-errors', 'GET', dataToSend, (response) => {
          this.loading = false
          if (response && response.status === true) {
            this.orders = response.data.orders
            this.pagination.total = response.data.total
            this.selectedIds = []
          } else {
            this.showError(response)
          }
        })
      },
      onSelectionChange (rows) {
        this.selectedIds = rows.map(row => row.id)
      },
      resend () {
        if (!this.selectedIds.length || this.resending) return

        this.resending = true
        const dataToSend = {
          token: this.$session.get('token'),
          company_id: this.companyID,
          order_ids: this.selectedIds
        }
        this.apiRequest('/gestiune/order-resend', 'POST', dataToSend, (response) => {
          this.resending = false
          if (response && response.status === true) {
            const { success, error } = response.data
            swal({
              icon: error ? 'warning' : 'success',
              title: 'Retrimitere finalizată',
              text: `Trimise cu succes: ${success}. Cu eroare: ${error}.`
            })
            this.fetchOrders()
          } else {
            this.showError(response)
          }
        })
      },
      openLogs (row, column) {
        if (column && column.type === 'selection') return

        this.logsOrderId = row.id
        this.logs = []
        this.logsLoading = true
        this.$modal.show('gestiuneOrderLogsModal')

        const dataToSend = {
          token: this.$session.get('token'),
          company_id: this.companyID,
          order_id: row.id
        }
        this.apiRequest('/gestiune/order-logs', 'GET', dataToSend, (response) => {
          this.logsLoading = false
          if (response && response.status === true) {
            this.logs = response.data.logs
          } else {
            this.showError(response)
          }
        })
      },
      pretty (value) {
        if (value === null || value === undefined || value === '') return '-'
        if (typeof value === 'string') return value
        return JSON.stringify(value, null, 2)
      },
      copyJson (value, key) {
        const text = this.pretty(value)
        const done = () => {
          this.copiedKey = key
          setTimeout(() => {
            if (this.copiedKey === key) this.copiedKey = null
          }, 2000)
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).then(done).catch(() => this.fallbackCopy(text, done))
        } else {
          this.fallbackCopy(text, done)
        }
      },
      fallbackCopy (text, done) {
        const textarea = document.createElement('textarea')
        textarea.value = text
        textarea.style.position = 'fixed'
        textarea.style.opacity = '0'
        document.body.appendChild(textarea)
        textarea.select()
        try {
          document.execCommand('copy')
          done()
        } catch (e) {}
        document.body.removeChild(textarea)
      },
      showError (response) {
        let errorMsg = 'A apărut o problemă.'
        if (response && response.errors && response.errors.length > 0) {
          errorMsg = response.errors.join(', ')
        }
        swal({ icon: 'error', title: 'Eroare', text: errorMsg })
      }
    }
  }
</script>

<style scoped>
  .info-text {
    margin-bottom: 20px;
    font-size: 13px;
    font-weight: 400;
    color: #000;
    background-color: white;
    padding: 7px 10px;
    border-radius: 9px;
    box-shadow: 0 6px 10px -4px rgba(0, 0, 0, 0.1);
  }
  .filters-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
    margin-bottom: 15px;
  }
  .filters-row .form-control {
    width: auto;
    min-width: 180px;
    height: 46px;
  }
  .only-final {
    display: flex;
    align-items: center;
    gap: 5px;
    margin: 0;
    font-weight: normal;
  }
  .clickable-rows >>> .el-table__row {
    cursor: pointer;
  }
  .last-error {
    font-weight: 500;
  }
  .last-details {
    color: #888;
  }
  .logs-modal-body {
    max-height: 60vh;
    overflow-y: auto;
    padding-right: 6px;
  }
  .log-entry {
    border: 1px solid #e5e5e5;
    border-left-width: 4px;
    border-radius: 6px;
    padding: 10px;
    margin-bottom: 12px;
  }
  .log-entry.log-error {
    border-left-color: #dc3545;
  }
  .log-entry.log-success {
    border-left-color: #28a745;
  }
  .log-head {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    align-items: center;
    margin-bottom: 6px;
  }
  .log-error-text {
    color: #dc3545;
    margin-bottom: 8px;
  }
  .log-json {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
  }
  .json-label {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .copy-json {
    cursor: pointer;
    font-size: 12px;
    user-select: none;
    margin-right: 15px;
  }
  .log-json pre {
    max-height: 220px;
    overflow: auto;
    background: #f7f7f9;
    padding: 8px;
    border-radius: 4px;
    font-size: 11px;
    white-space: pre-wrap;
    word-break: break-word;
  }
  @media (max-width: 900px) {
    .log-json {
      grid-template-columns: 1fr;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/ManagementOrderErrors.vue